import { defineMessages } from "react-intl";

const messages = defineMessages({
  regenerateTooltip: {
    id: "email.creation.aiInlineWriter.regenerate.tooltip",
    defaultMessage: "Regenerate",
    description: "Tooltip for the regenerate button",
  },
  reportTooltip: {
    id: "email.creation.aiInlineWriter.report.tooltip",
    defaultMessage: "Report",
    description: "Tooltip for the report button",
  },
  thinking: {
    id: "email.creation.aiInlineWriter.thinking",
    defaultMessage: "Thinking...",
    description: "Thinking text when generating response",
  },
  undoTooltip: {
    id: "email.creation.aiInlineWriter.undo.tooltip",
    defaultMessage: "Undo",
    description: "Tooltip for the undo button",
  },
});

export default messages;
